import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import companySlice from "./slices/companySlice";
import shipmentSlice from "./slices/shipmentSlice";
import driverSlice from "./slices/driverSlice";
import partnerSlice from "./slices/partnersSlice";
import commentSlice from "./slices/commentSlice";
import notificationSlice from "./slices/notificationSlice";
import languageSlice from "./slices/languageSlice";
import addressesSlice from "./slices/addressesSlice";
import vehicleSlice from "./slices/vehiclesSlice";
import serviceSlice from "./slices/servicesSlice";
import costServiceSlice from "./slices/costServicesSlice";
import dashboardSlice from "./slices/dashboardSlice";
import calendarSlice from "./slices/calendarSlice";
import shipmentGroupSlice from "./slices/shipmentGroupSlice";
import networkSlice from "./slices/networkSlice";
import tasksSlice from "./slices/tasksSlice";
import worksSlice from "./slices/worksSlice";
import invoicesSlice from "./slices/invoicesSlice";
import ordersSlice from "./slices/ordersSlice";
import containerOrdersSlice from "./slices/containerOrdersSlice";
import modulesSlice from "./slices/modulesSlice";

// SuperAdmin
import superAdminAuthSlice from "./slices/superAdminAuthSlice";
import superAdminCompanySlice from "./slices/superAdminCompanySlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    users: userSlice,
    company: companySlice,
    shipment: shipmentSlice,
    driver: driverSlice,
    partner: partnerSlice,
    comments: commentSlice,
    notifications: notificationSlice,
    language: languageSlice,
    addresses: addressesSlice,
    vehicles: vehicleSlice,
    services: serviceSlice,
    costServices: costServiceSlice,
    dashboard: dashboardSlice,
    calendar: calendarSlice,
    shipmentGroup: shipmentGroupSlice,
    network: networkSlice,
    tasks: tasksSlice,
    works: worksSlice,
    invoices: invoicesSlice,
    orders: ordersSlice,
    containerOrders: containerOrdersSlice,
    modules: modulesSlice,
    superAdminAuth: superAdminAuthSlice,
    superAdminCompanies: superAdminCompanySlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
